export default {
	title: 'リスク / 突破口',
	risks: 'リスク',
	opportunities: '突破口',
	url: 'risks',
	subtitle: '',
	all_categories: 'カテゴリで絞り込み',
	all_impacts: '影響で絞り込み',
	all_likelihoods: '発生可能性で絞り込み',
	all_stakeholders: 'ステークホルダーで絞り込み',
	all_stakes: 'ステークで絞り込み',
	no_stakeholder: 'ステークホルダーなし',
	tabs: {
		filters: {
			title: '表示フィルター',

			displayed_columns: '表示列',
			visualization_options: 'ビジュアル設定'
		},
		options: {
			title: '表示',
			are_links_visible: 'すべてのリンクを表示',
			show_description: '説明を表示',
			chart_visible_stakes: 'ステークを表示',
			chart_visible_stakeholders: 'ステークホルダーを表示',
			chart_visible_risks: 'リスクを表示',
			chart_visible_opportunities: '突破口を表示'
		},
		general: {
			title: '一般'
		},
		stakeholders: {
			title: 'ステークホルダー'
		},
		export: {
			title: 'エクスポート'
		},
		comments: {
			title: '履歴'
		}
	},
	visualization_tab: 'ビジュアル',
	onboarding: {
		risks: {
			title: 'リスクの確認',
			description:
				'これらは、あなたのステークにのしかかるリスクです。発生可能性と影響を評価し、不適切に較正されていると思われるものを修正してください。'
		},
		opportunities: {
			title: '突破口の確認',
			description:
				'リスクとは逆に、突破口はステークを強化するダイナミクスです。実行可能なものを残し、それ以外は脇に置いてください。'
		}
	}
};
